import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ReservationModel } from '../models/ReservationModel';
import { URLsConfig } from '../URLsConfig';
import { ReservationVModel } from '../models/ReservationVModel';


@Injectable()
export class ReservationService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getReservation(resDate: string, resRoom: string , compCode: string) {
      let params = new HttpParams();
        params = params.append("resDate", resDate);
        params = params.append("resRoom", resRoom);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };

      return this.http.get<ReservationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/GetReservation',options);
    }
    public getReservationDoctor(resDate: string, resDoc: string , compCode: string) {
      let params = new HttpParams();
        params = params.append("resDate", resDate);
        params = params.append("ResDoc", resDoc);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };

      return this.http.get<ReservationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/GetReservationDoctor',options);
    }
    public getReservationDate(resDate: string , compCode: string) {
      let params = new HttpParams();
        params = params.append("resDate", resDate);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };

      return this.http.get<ReservationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/GetReservationDate',options);
    }
    public getReservationG(resDate: string, resRoom: string , compCode: string) {
      let params = new HttpParams();
        params = params.append("resDate", resDate);
        params = params.append("resRoom", resRoom);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };

      return this.http.get<ReservationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/GetReservationG',options);
    }

    public AddRese(reservation: ReservationModel) {
        return this.http.post<ReservationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/AddReservation', reservation);
    }
    public UpdateRese(reservation: ReservationModel) {
      return this.http.post<ReservationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/UpdateReservation', reservation);
  }
    public delReservation(resDate: string,resRoom: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("resDate", resDate);
        params = params.append("resRoom", resRoom);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<ReservationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/DeleteReservationAll',options);
    }

    public delReservation_Line(patientCode:string, resDate: string, resRoom: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("resDate", resDate);
        params = params.append("resRoom", resRoom);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<ReservationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/DeleteReservationLine',options);
    }
    public delReservation_Line_1(id:number,  compCode: string) {

      let params = new HttpParams();
        params = params.append("ID", id);

        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<ReservationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/DeleteReservationLine_1',options);
    }
    public getDaileyReservation(resDate: string,RoomType:string, resRoom: string,resDoc:string,resType:string ,resStatus:string, compCode: string) {
      let params = new HttpParams();
        params = params.append("resDate", resDate);
        params = params.append("RoomType", RoomType);
        params = params.append("resRoom", resRoom);
        params = params.append("resDoc", resDoc);
        params = params.append("resType", resType);
        params = params.append("resStatus", resStatus);
        const options = {
          params: params
      };

      return this.http.get<ReservationVModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Reservation/DailyReservationLookup',options);
    }
  }
